import CoreApiClient from './core-api-client';
import { mapAxiosResponse } from '../utils/api-utils';

export default class NotificationService {

  static async notifyJobTechnician(inviteCode: string, content: string) {
    const resp = await CoreApiClient.post(`/task/notify_agent`, {
      invite_code: inviteCode,
      template: content,
    });

    return mapAxiosResponse(resp);
  }
}